import React, {useState} from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Button, TextField, Typography, Stack, CircularProgress } from '@mui/material';

import { changePlayerName } from '../../actions/player';
import { createPlayQuiz } from '../../actions/playQuiz';
import Language from '../Language/Language';
import Panel from '../../Elements/Panel';
import { COLOR_SECONDARY, COLOR_TEXT_MUTED, COLOR_TEXT_PRIMARY } from '../../constants/styleValues';


const ChooseMode = () => {

    //Variables
    const dispatch = useDispatch();
    
    //every text is stored within this constant
    //translation are done here - just enter a different language
    const componentContent = {
        language_DE:{
            welcomeMessage:['Willkommen!','Hallo!','Wundervollen Guten Tag!','Herzlich Willkommen!','Grüezi!','Salut!','Bienvenue!','Ciao!','Howdy!','Aloha!','Namaste!','Hola!','Guten Morgen!','Servus!','Hi!','Moin!','Good day!','Buongiorno!','Hej!','Shalom!'],
            welcomeName:['Clever Cat','Quiz Whiz','Smarty Pants','Brainy Bunny','Quiz Master','Genius Giraffe','Smart Cookie','Quiz King/Queen','Brain Buff','Trivia Titan','Knowledge Ninja','Wise Owl','Brainiac Bob/Bella','Quiz Quokka','IQ Iguana','Professor Puzzle','Trivia Tiger','Clever Cucumber','Quiz Wizard','Smarty Shark'],
            createQuiz:'Neues Quiz starten',
            joinQuiz:'Quiz beitreten',
            changeName:'Name ändern',
            saveName:'Name speichern',
            privacy:'Datenschutzerklärung',
            partner:'Unsere Partner',
            howItWorks:'Wie funktioniert\'s?',
            blog:'Blog'
        },
        language_EN:{
            welcomeMessage:['Willkommen!','Hallo!','Wundervollen Guten Tag!','Herzlich Willkommen!','Grüezi!','Salut!','Bienvenue!','Ciao!','Howdy!','Aloha!','Namaste!','Hola!','Guten Morgen!','Servus!','Hi!','Moin!','Good day!','Buongiorno!','Hej!','Shalom!'],
            welcomeName:['Clever Cat','Quiz Whiz','Smarty Pants','Brainy Bunny','Quiz Master','Genius Giraffe','Smart Cookie','Quiz King/Queen','Brain Buff','Trivia Titan','Knowledge Ninja','Wise Owl','Brainiac Bob/Bella','Quiz Quokka','IQ Iguana','Professor Puzzle','Trivia Tiger','Clever Cucumber','Quiz Wizard','Smarty Shark'],
            createQuiz:'Start new Quiz',
            joinQuiz:'Join Quiz',
            changeName:'Change Name',
            saveName:'Save Name',
            privacy:'Privacy Statement',
            partner:'Our Partners',
            howItWorks:'How it works',
            blog:'Blog'
        },
        language_FR:{
            welcomeMessage:['Willkommen!','Hallo!','Wundervollen Guten Tag!','Herzlich Willkommen!','Grüezi!','Salut!','Bienvenue!','Ciao!','Howdy!','Aloha!','Namaste!','Hola!','Guten Morgen!','Servus!','Hi!','Moin!','Good day!','Buongiorno!','Hej!','Shalom!'],
            welcomeName:['Clever Cat','Quiz Whiz','Smarty Pants','Brainy Bunny','Quiz Master','Genius Giraffe','Smart Cookie','Quiz King/Queen','Brain Buff','Trivia Titan','Knowledge Ninja','Wise Owl','Brainiac Bob/Bella','Quiz Quokka','IQ Iguana','Professor Puzzle','Trivia Tiger','Clever Cucumber','Quiz Wizard','Smarty Shark'],
            createQuiz:'Créer un quiz',
            joinQuiz:'Rejoindre un quiz',
            changeName:'Changer le nom',
            saveName:'Enregistrer le nom',
            privacy:'Privacy Statement',
            partner:'Nos Partenaires',
            howItWorks:'Comment ça marche',
            blog:'Blog'
        },
    }
    
    //++++++++++++++++STORE SELECTOR++++++++++++++++
    const playerName = useSelector((state) => state.Cookie.playerName); //get the current player name based on the cookie
    const playerId = useSelector((state) => state.Cookie.playerId); //get the current player name based on the cookie
    const selectedLanguage = useSelector((state) => state.Language);


    const randomWelcome = Math.floor(Math.random() * componentContent[selectedLanguage].welcomeMessage.length); //Random number to generate Welcome Message
    const randomName = Math.floor(Math.random() * componentContent[selectedLanguage].welcomeName.length); //Random number to generate Placerholder Name

    //++++++++++++++++STATE SETTINGS++++++++++++++++++

    //Show and hide the edit objects
    const [editNameMode, setEditNameVisibility] = useState(
        {
            editObjects:'none',
            defaultObjects: 'inline-flex'
        }
    );
    
    //store the player data (new Name)
    const [playerData, setPlayerData] = useState(
        {
            playerId: playerId,
            playerName:playerName,
        }
    );

    //function to set the play quiz data
    const [playQuizData, setPlayQuizData] = useState(//playQuizData which is send to db to create a new playQuiz data object. Content come from the selected quiz
        { 
            hostId: playerId,
            playerId: playerId,
            playerName:playerName
        }
    );

    //+++++++++++++++++FUCNTIONS++++++++++++++++++++ 
    //show the edit objects to edit the name
    const handleEditName = () => {
        setEditNameVisibility(
            {
                editObjects:'inline-flex',
                defaultObjects: 'none'
            }
        )
    }

    //hide the edit objects to edit the name
    const handleSaveNewName = (e) => {
        e.preventDefault();

        if(playerData.playerName !== ''){
            dispatch(changePlayerName(playerData));

            setEditNameVisibility(
                {
                    editObjects:'none',
                    defaultObjects: 'inline-flex'
                }
            )
        }
    }

    //changing the name input
    const handleChangeNameInput = (newName) => {
        setPlayerData(
            {
                playerId: playerId,
                playerName: newName,
            }        
        )

        setPlayQuizData(
            { 
                hostId: playerId,
                playerId: playerId,
                playerName:newName
            }
        )
    }

    //++++++++++++++++STATE SETTINGS++++++++++++++++++
    const [isCreatingQuiz, setIsCreatingQuiz] = useState(false);

    //create a quiz
    const handleCreateQuiz = async () => {
        setIsCreatingQuiz(true);
        await dispatch(createPlayQuiz(playQuizData));
        setIsCreatingQuiz(false);
    }
    return(
        <div>
        <Helmet>
            <title>Multiplayer Quiz - Free Online Quiz Game with Friends</title>
            <meta name="description" content="Play free multiplayer quiz games with friends online. Create a room, invite your friends and compete live - no download or signup required." />
            <link rel="canonical" href="https://multiplayer-quiz.com/" />
        </Helmet>
        <Grid container direction="column"  justifyContent="center" alignItems="center" textAlign="center" sx={{height: '100vH', px: {xs: 2, sm: 3}}}>
            <Language />
            <div>
                <Typography variant="body1">{componentContent[selectedLanguage].welcomeMessage[randomWelcome]}</Typography>
                <Typography variant="h1" sx={{display:editNameMode.defaultObjects}}>{playerName ? playerName : componentContent[selectedLanguage].welcomeName[randomName]}</Typography>
                <form autoComplete='off' noValidate onSubmit={handleSaveNewName}>
                    <TextField
                        defaultValue={playerName}
                        variant="outlined"
                        focused
                        sx={{
                            display:editNameMode.editObjects,
                            backgroundColor: 'rgba(255,255,255,0.08)',
                            borderRadius: '8px',
                            input: { color: COLOR_TEXT_PRIMARY }
                        }}
                        onChange={(e) => handleChangeNameInput(e.target.value)}
                    />
                </form>
            </div>
            <Stack mt={2} spacing={1}>
                <Button variant="text" size="small" sx={{display:playerName ? editNameMode.defaultObjects :"none"}} onClick={handleEditName}>{componentContent[selectedLanguage].changeName}</Button>
                <Button variant="text" size="small" type="submit" sx={{display:editNameMode.editObjects}} onClick={handleSaveNewName}>{componentContent[selectedLanguage].saveName}</Button>
                <Button
                    variant="contained"
                    size="large"
                    onClick={handleCreateQuiz}
                    disabled={isCreatingQuiz}
                    startIcon={isCreatingQuiz ? <CircularProgress size={18} color="inherit" /> : null}
                >
                    {componentContent[selectedLanguage].createQuiz}
                </Button>
                <Button variant="outlined" size="large" color="primary" href='/play'>{componentContent[selectedLanguage].joinQuiz}</Button>
                <Button variant="text" size="small" href="/how-it-works" sx={{color: COLOR_TEXT_MUTED, mt: 1}}>{componentContent[selectedLanguage].howItWorks}</Button>

            </Stack>
        </Grid>
        <Grid container justifyContent="center" alignItems="center" textAlign="center" mb={5} sx={{px: {xs: 2, sm: 3}}}>
            <Grid container maxWidth="lg" justifyContent="center" textAlign="center" spacing={1}>
                <Grid item xs={12} mb={3}>
                    <Typography variant='h2'>{componentContent[selectedLanguage].partner}</Typography>
                </Grid>
                {[
                    { href: "https://advisory42.com/", img: "/images/sponsor_advisory42.jpg", name: "advisory42" },
                    { href: "https://amodoro.de/", img: "/images/sponsor_amodoro.png", name: "amodoro" },
                    { href: "https://baumfink.de/", img: "/images/sponsor_baumfink.png", name: "Baumfink" },
                    { href: "https://www.landhafen.com/", img: "/images/sponsor_landhafen.jpg", name: "Hotel Landhafen" },
                    { href: "https://microharvest.com/", img: "/images/sponsor_microharvest.png", name: "MicroHarvest" },
                    { href: "https://sc-victoria.de/", img: "/images/sponsor_vicky.png", name: "SC Victoria Hamburg" },
                    { href: "https://cucinaria-kochschule.de/", img: "/images/sponsor_treatit.png", name: "treatit" },
                ].map((sponsor) => (
                    <Grid item xs={6} sm={3} md={2} key={sponsor.href}>
                        <Panel sx={{p: 1.5}}>
                            <Button href={sponsor.href} target="_blank" sx={{width: '100%'}}>
                                <div>
                                    <div style={{ height: '40px'}}>
                                        <img src={sponsor.img} alt={"sponsor " + sponsor.name} style={{ maxHeight: '40px', maxWidth:'140px'}}/>
                                    </div>
                                    <div style={{ height: '20px'}}>
                                        <p style={{margin:0, color: COLOR_SECONDARY, textTransform:"none"}}>{sponsor.name}</p>
                                    </div>
                                </div>
                            </Button>
                        </Panel>
                    </Grid>
                ))}
            </Grid>
        </Grid>
        <Grid container justifyContent="center" alignItems="center" textAlign="center" sx={{px: {xs: 2, sm: 3}, pb: 3}}>
            <Button variant='text' href="/blog" sx={{color: COLOR_TEXT_MUTED, mr: 2}}>{componentContent[selectedLanguage].blog}</Button>
            <Button variant='text' href="/impressum" sx={{color: COLOR_TEXT_MUTED}}>Impressum & {componentContent[selectedLanguage].privacy}</Button>
        </Grid>
        </div>
    )

}

export default ChooseMode